import { Observable } from "rxjs";

import type { GovernanceVotingHistoryParams } from "@coin-depo-types";

export interface VotingHistoryFacade {
  cachedIsUserHasVoting$: Observable<boolean>;
  cachedVotesList$: Observable<any>;

  getGovernanceVotingHistory(params: GovernanceVotingHistoryParams): Observable<any>;

  getGovernanceVotingHistoryCSV?(params: GovernanceVotingHistoryParams): Observable<Blob>;

  getIsUserHasVotingSnapshot(): boolean;

  getVotesListSnapshot(): any;
}